var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 960 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 990,
    y1: 1050,
    x2: -30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e64d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b6bf3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "url(#c)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.75,704.16c-14.8-35.2-36.1-66.7-63.2-93.8-27.1-27.1-58.6-48.4-93.8-63.2-36.4-15.4-75.1-23.2-114.9-23.2s-78.5,7.8-114.9,23.2c-35.2,14.8-66.7,36.1-93.8,63.2-27.1,27.1-48.4,58.6-63.2,93.8-15.4,36.4-23.2,75.1-23.2,114.9s7.8,78.5,23.2,114.9c14.9,35.2,36.1,66.7,63.2,93.8,27.1,27.1,58.6,48.4,93.8,63.2,36.4,15.4,75.1,23.2,114.9,23.2s78.5-7.8,114.9-23.2c35.2-14.9,66.7-36.1,93.8-63.2,27.1-27.1,48.4-58.6,63.2-93.8,15.4-36.4,23.2-75.1,23.2-114.9.1-39.8-7.7-78.5-23.2-114.9h0ZM171.85,1034.26c-118.8,0-215.2-96.3-215.2-215.2s96.4-215.2,215.2-215.2,215.2,96.3,215.2,215.2-96.4,215.2-215.2,215.2Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.08,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48,977.61c-15.9-37.5-38.6-71.2-67.5-100.1-28.9-28.9-62.6-51.6-100.1-67.5-38.9-16.5-80.2-24.8-122.7-24.8s-83.8,8.3-122.7,24.8c-37.5,15.9-71.2,38.6-100.1,67.5-28.9,28.9-51.6,62.6-67.5,100.1-16.5,38.9-24.8,80.2-24.8,122.7s8.3,83.8,24.8,122.7c15.9,37.5,38.6,71.2,67.5,100.1,28.9,28.9,62.6,51.6,100.1,67.5,38.9,16.5,80.2,24.8,122.7,24.8s83.8-8.3,122.7-24.8c37.5-15.9,71.2-38.6,100.1-67.5,28.9-28.9,51.6-62.6,67.5-100.1,16.5-38.9,24.8-80.2,24.8-122.7s-8.3-83.8-24.8-122.7h0ZM11.08,1315.51c-118.8,0-215.2-96.3-215.2-215.2s96.3-215.2,215.2-215.2,215.2,96.3,215.2,215.2-96.3,215.2-215.2,215.2Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.08,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.05,79.32c-15.2-36-37-68.3-64.7-96-27.7-27.7-60-49.5-96-64.7-37.3-15.8-76.9-23.8-117.6-23.8s-80.3,8-117.6,23.8c-36,15.2-68.3,37-96,64.7-27.7,27.7-49.5,60-64.7,96-15.8,37.3-23.8,76.9-23.8,117.6s8,80.3,23.8,117.6c15.2,36,37,68.3,64.7,96,27.7,27.7,60,49.5,96,64.7,37.3,15.8,76.9,23.8,117.6,23.8s80.3-8,117.6-23.8c36-15.2,68.3-37,96-64.7,27.7-27.7,49.5-60,64.7-96,15.8-37.3,23.8-76.9,23.8-117.6s-8-80.3-23.8-117.6ZM1030.75,439.02c-133.7,0-242.1-108.4-242.1-242.1s108.4-242.1,242.1-242.1,242.1,108.4,242.1,242.1-108.4,242.1-242.1,242.1Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.08,
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBackground);
export default __webpack_public_path__ + "static/media/step-background.c4578932249495bcc22f8ca769e488ad.svg";
export { ForwardRef as ReactComponent };